/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, April 21st 2023, 7:53:58 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { SubscriptionPlan } from "saas-subscription/schemas";
import { COLORSCHEME, RGBTriplets } from "theme/styles";
// import { EnterpriseIcon } from "theme/icons";

interface ISubscriptionPlanWidgets {
  shortName: string;
  packageColor?: React.CSSProperties["backgroundColor"];
  packageGradient?: React.CSSProperties["background"];
  packageRGBTriplets?: string;
  upgradeText: string;
  graphic: React.ReactNode;
}

type IPackageWidgets = { [k in SubscriptionPlan["metadata"]["product_code"]]: ISubscriptionPlanWidgets };

export const PackageWidgets: IPackageWidgets = {
  "onestop-free": {
    shortName: "Free",
    upgradeText: "Downgrade to Free",
    graphic: null,
    packageColor: "rgb(105,105,105)",
    packageRGBTriplets: "105,105,105",
    packageGradient: "linear-gradient( 4deg, rgb(105,105,105, 10%) -20%, rgb(105,105,105, 40%) 60%)",
  },
  "onestop-lite": {
    shortName: "Lite",
    upgradeText: "Upgrade to Lite",
    graphic: null,
    packageColor: "rgb(255,165,0)",
    packageRGBTriplets: "255,165,0",
    packageGradient: "linear-gradient( 4deg, rgb(255,165,0, 10%) -20%, rgb(255,165,0, 40%) 60%)",
  },
  "onestop-pro": {
    shortName: "Pro",
    upgradeText: "Upgrade to Pro",
    graphic: null,
    packageColor: COLORSCHEME.primary,
    packageRGBTriplets: RGBTriplets.primary,
    packageGradient: "linear-gradient( 4deg, rgb(204, 0, 153, 10%) -20%, rgb(123, 0, 177, 30%) 60%)",
  },
  "onestop-premium": {
    shortName: "Premium",
    upgradeText: "Upgrade to Premium",
    graphic: null,
    packageColor: COLORSCHEME.secondary,
    packageRGBTriplets: RGBTriplets.secondary,
    packageGradient: "linear-gradient( 4deg, rgb(204, 0, 153, 10%) -20%, rgb(204, 0, 153, 40%) 60%) ",
  },
  "onestop-enterprise": {
    shortName: "Enterprise",
    upgradeText: "Contact us",
    // graphic: <EnterpriseIcon height={128} width={128} />,
    graphic: null,
    packageColor: "rgb(32, 12, 245)",
    packageRGBTriplets: "32, 12, 245",
    packageGradient: "linear-gradient( 4deg, rgb(32, 12, 245, 10%) -20%, rgb(32, 12, 245, 40%) 60%) ",
  },
};
